import React, { useState } from 'react';
import { BroadcastChannel } from 'broadcast-channel';
import Logo from '../../Logo';
import {
  BROADCAST_CHANNEL_NAME,
  MessageTypes,
  getSsoFailureMessage,
} from '../constants';

const getSsoAction = () => {
  const isLocalhost = window.location.hostname === 'localhost';
  const hasPort = window.location.port;
  const baseURL = isLocalhost && hasPort ? 'http://localhost:5005' : '';
  return `${baseURL}/api/v3/user/authenticate/sso`;
};

export const RedirectForm = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) {
      return;
    }

    const form = event.currentTarget;
    const email = form.email.value;
    setSubmitting(true);
    setError('');

    try {
      const response = await fetch('/api/v3/user/authenticate/sso', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `email=${encodeURIComponent(email)}`,
        redirect: 'manual',
        credentials: 'same-origin',
      });

      const isRedirect =
        response.type === 'opaqueredirect' ||
        (response.status >= 300 && response.status < 400);

      if (isRedirect || response.ok) {
        form.submit();
        return;
      }

      let errorCode;
      try {
        const data = await response.json();
        errorCode = data && data.errors && data.errors[0];
      } catch (parseError) {
        errorCode = undefined;
      }

      const errorData = errorCode ? { errors: [errorCode] } : null;
      const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
      channel.postMessage({
        type: MessageTypes.ssoFail,
        errorStatus: response.status,
        errorCode,
      });
      setError(
        getSsoFailureMessage({
          errorStatus: response.status,
          errorData,
        }),
      );
      setSubmitting(false);
      if (window.opener && !window.opener.closed) {
        window.opener.focus();
      }
      window.setTimeout(() => {
        window.close();
      }, 50);
    } catch (requestError) {
      form.submit();
    }
  };

  return (
    <section className="sso-page">
      <div style={{ flex: 1 }}>
        <div style={{ marginTop: 8, marginBottom: 8 }}>
          <Logo />
        </div>
        <h4
          className="text-align-left"
          style={{ marginBottom: 18, marginTop: 0 }}
        >
          Sign in with Single Sign-on
        </h4>
        <div className="sso-form">
          <form action={getSsoAction()} method="POST" onSubmit={handleSubmit}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              name="email"
            />
            {error ? (
              <div className="pf-form__message pf-form__message--error">
                {error}
              </div>
            ) : null}
            <button type="submit" disabled={submitting}>
              Submit
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default RedirectForm;
